<template>
  <div class="md-layout" v-if="accom">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <h4 class="title">
          Details
        </h4>
      </md-card-header>
      <md-card-content>
        <form>
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Company</label>
                <md-input
                  v-model="accom.company"
                  type="text"
                  ref="title"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Contact Name</label>
                <md-input v-model="accom.contact_name" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Contact Number</label>
                <md-input v-model="accom.tel_num" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Email Address</label>
                <md-input v-model="accom.email" type="email"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Address</label>
                <md-input v-model="accom.address_1" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Address</label>
                <md-input v-model="accom.address_2" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>City</label>
                <md-input v-model="accom.city" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>County/State</label>
                <md-input v-model="accom.county" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label for="country">Country</label>
                <md-select v-model="accom.country" name="country" id="country">
                  <md-option
                    v-for="country in countries"
                    :key="country"
                    :value="country"
                  >
                    {{ country }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Postcode</label>
                <md-input v-model="accom.postcode" type="text"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button
                class="md-raised md-success mt-4"
                @click.prevent="update"
                >{{ updateButtonText }}</md-button
              >
            </div>
          </div>
        </form>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import accomApi from "@/services/api/accom";
import optionsApi from "@/services/api/options";

export default {
  props: ["accom"],

  data() {
    return {
      countries: []
    };
  },

  computed: {
    updateMode: function() {
      return this.accom.id ? "UPDATE" : "CREATE";
    },
    updateButtonText: function() {
      return this.updateMode == "UPDATE" ? "Update" : "Add";
    }
  },

  methods: {
    update() {
      let save = null;
      let message = "";

      switch (this.updateMode) {
        case "UPDATE":
          save = accomApi.updateAccom(this.accom);
          message = "Updated!";
          break;

        default:
          save = accomApi.createAccom(this.accom);
          message = "Added!";
      }

      save.then(response => {
        this.$notify({
          timeout: 2500,
          message: message,
          icon: "thumb_up",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        });

        this.$emit("accomUpdated", {
          accom: response.data,
          mode: this.updateMode
        });
      });
    }
  },

  created() {
    optionsApi.countries().then(response => {
      this.countries = response.data;
    });
  }
};
</script>
